import PubSub from "underpub-js";
import gsap from "gsap";
import ImgixClient from "@imgix/js-core";

const client = new ImgixClient({
	domain: 'amplify-10120sriversideplaza.imgix.net',
});

var BuildingVisualizer = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BuildingVisualizer',
	};

	$.extend(true, this.options, options);

};

BuildingVisualizer.prototype.init = function() {

	const self = this;

	self.loadingTimer = 0;
	self.minLoadTime = 600;
	self.ajaxRequest = null;
	self.loadCompleteTimeline = null;
	self.loadCompleteTimeout = null;

	self.$availableSuites = self.options.$el.find(`.${self.options.baseClass}__space--available`);

	self.$modalOverlay = self.options.$el.find(`.${self.options.baseClass}__suiteModalOverlay`);
	self.$modal = self.options.$el.find(`.${self.options.baseClass}__suiteModal`);
	self.$modalContentWrapper = self.options.$el.find(`.${self.options.baseClass}__suiteModal__contentWrapper`);
	self.$modalCloseButton = self.options.$el.find(`.${self.options.baseClass}__suiteModal__closeButton`);
	self.$modalLoader = self.options.$el.find(`.${self.options.baseClass}__suiteModal__loader`);

	self.dataContainerAttribute = "data-modal-suite-data-container";
	self.$dataContainers = self.options.$el.find(`[${self.dataContainerAttribute}]`);

	// click handlers
	self.$availableSuites.on('click', function() {
		self.handleSuiteClick( $(this).data('suiteId') );
	});
	self.$modalCloseButton.on('click', () => { self.hideModal(); });
	self.$modalOverlay.on('click', () => { self.hideModal(); });
	self.$modal.on('click', (e) => { e.stopPropagation(); });

	gsap.defaults({ overwrite: "auto" });

};

BuildingVisualizer.prototype.handleSuiteClick = function(suiteId) {

	const self = this;

	self.resetModal();
	self.showModalLoader();
	self.showModal();
	self.loadSuiteData(suiteId);

};

BuildingVisualizer.prototype.showModalLoader = function() {

	const self = this;

	self.loadingTimer = Date.now();

	gsap.set(self.$modalLoader, {
		opacity: 1,
		zIndex: 1,
		visibility: "visible",
	})

};

BuildingVisualizer.prototype.loadingComplete = function() {

	const self = this;

	// prevent the loader from immediately disappearing on fast loads, because it doesn't look good
	if (Date.now() - self.loadingTimer < self.minLoadTime) {
		console.log("Wait");
		console.log("Timer start: " + self.loadingTimer);
		console.log("Now: " + Date.now());
		console.log("Difference: " + (Date.now() - self.loadingTimer));
		self.loadCompleteTimeout = setTimeout(function() {
			self.loadingComplete();
		}, 100);
		return;
	}

	self.loadCompleteTimeline = gsap
		.timeline({
			defaults: {}
		})
		.to(self.$modalContentWrapper, {
			duration: 0.45,
			height: "auto",
		})
		.to(self.$modalLoader, {
			duration: 0.35,
			ease: "none",
			opacity: 0,
		}, ">-0.1")
		.set(self.$modalLoader, {
			zIndex: -1,
			visibility: "hidden",
		})

};

BuildingVisualizer.prototype.showModal = function() {

	const self = this;

	gsap
		.timeline({
			defaults: {

			}
		})
		.set(self.$modalOverlay, {
			// clearProps: "zIndex,visibility",
			zIndex: 300,
			visibility: "visible",
		})
		.to(self.$modalOverlay, {
			duration: 0.25,
			opacity: 1
		})
		.to(self.$modal, {
			duration: 0.4,
			y: 0,
		}, "<")

};

BuildingVisualizer.prototype.hideModal = function() {

	const self = this;

	gsap
		.timeline({
			defaults: {
				duration: 0.2,
			}
		})
		.to(self.$modalOverlay, {
			opacity: 0
		})
		.set(self.$modalOverlay, {
			zIndex: -1,
			visibility: "hidden",
		})
		.set(self.$modal, {
			y: 10,
		})

};

BuildingVisualizer.prototype.resetModal = function() {

	const self = this;

	// kill anything that might still be running from a previous request
	if (self.ajaxRequest) {
		self.ajaxRequest.abort();
	}
	if (self.loadCompleteTimeout) {
		clearTimeout(self.loadCompleteTimeout);
	}
	if (self.loadCompleteTimeline) {
		self.loadCompleteTimeline.kill();
	}

	let modalHeight = self.$modalContentWrapper.outerHeight();
	gsap.set(self.$modalContentWrapper, {
		height: modalHeight,
	});

	self.$dataContainers.attr(self.dataContainerAttribute, "inactive");

	self.$dataContainers.each((index, element) => {
		const $dataContainer = $(element);

		if (!$dataContainer.children().length) {
			$dataContainer.text("");
		}

		if ($dataContainer.children("li").not("[data-modal-unit-data-container]").length) {
			$dataContainer.children("li").not("[data-modal-unit-data-container]").remove();
		}
	});

};

BuildingVisualizer.prototype.loadSuiteData = function(suiteId) {

	const self = this;

	if (typeof suiteId != "number") return;

	let suiteQuery = `
		query MyQuery {
			entry(id: "${suiteId}") {
				id
				... on suites_suite_Entry {
					id
					title
					suite_availability
					suite_floor
					suite_sizeSquareFeet
					suite_floorPlanDownload {
						url
					}
					suite_floorPlanImage(limit: 1) {
						id
						path
						title
						url @transform(width:1360, height: 720, mode: "fit")
					}
				}
			}
		}
	`;

	self.ajaxRequest = $.ajax({
		type: 'POST',
		url: '/api',
		data: {
			query: suiteQuery
		},
		success: (data) => {
			if (typeof data.data == "undefined") {
				console.log('There was an error loading suite details.', data);
				// self.displayError();
				return;
			}

			const suiteData = data.data.entry;

			if (!suiteData) {
				console.log('No suite data returned.');
				// self.displayError();
				return;
			}

			self.showSuiteData(suiteData);
		},
		error: (data) => {
			// self.displayError();
			console.log('There was an error loading unit details.', data);
		},
	});

};

BuildingVisualizer.prototype.showSuiteData = function(suiteData) {

	const self = this;

	const showDataContainer = element => {
		$(element).attr(self.dataContainerAttribute, "");
		$(element).parents(`[${self.dataContainerAttribute}]`).attr(self.dataContainerAttribute, "");
	}

	self.$heading = self.options.$el.find(`.${self.options.baseClass}__suiteModal__heading`);
	self.$details = self.options.$el.find(`.${self.options.baseClass}__suiteModal__details`);
	self.$downloadLink = self.options.$el.find(`.${self.options.baseClass}__suiteModal__downloadLinkWrapper .atom-ButtonSecondary`);
	self.$image = self.options.$el.find(`.${self.options.baseClass}__suiteModal__imageWrapper img`);

	// heading
	let heading = suiteData.title;
	if (heading && heading.length) {
		self.$heading.text(heading);
		showDataContainer(self.$heading);
	}

	// details
	let available = suiteData.suite_availability;
	let floor = suiteData.suite_floor;
	let squareFeet = suiteData.suite_sizeSquareFeet;
	if ((available && available.length) || (floor && floor.length) || (squareFeet && squareFeet > 0)) {

		let details = '';

		let availableDateString = 'Immediately';
		if (available && available.length) {

			let currentDate = new Date();
			let availableDate = new Date(available);
			
			if (availableDate > currentDate) {
				availableDateString = availableDate.toLocaleDateString();
			}

		}
		details += `<li>Available: ${availableDateString}</li>`;

		if (floor && floor.length) {
			details += `<li>Floor: ${floor}</li>`;
		}

		if (squareFeet && squareFeet > 0) {
			details += `<li>Size: ${squareFeet.toLocaleString()} RSF</li>`;
		}

		self.$details.html(details);

		showDataContainer(self.$details);

	}

	// image
	let floorPlanImageUrl;
	if (suiteData.suite_floorPlanImage && suiteData.suite_floorPlanImage.length) {
		
		let floorPlanImage = suiteData.suite_floorPlanImage[0];

		if (floorPlanImage) {

			floorPlanImageUrl = floorPlanImage.url;
			const floorPlanImageAlt = floorPlanImage.title;
			const floorPlanImagePath = floorPlanImage.path;

			if (floorPlanImagePath && floorPlanImagePath.length) {
				
				const imgixImageUrl = client.buildURL(`/images/${floorPlanImagePath}`, {
					width: 1360,
					ar: 680 / 360,
					fit: "clip",
				});

				if (imgixImageUrl && imgixImageUrl.length) {
					floorPlanImageUrl = imgixImageUrl;
				}

			}

			if (floorPlanImageUrl.length) {
				showDataContainer(self.$image);
				self.$image.attr('src', floorPlanImageUrl);

				if (self.$image[0].complete) {
					self.loadingComplete();
				}
				else {
					self.$image.replaceWith(self.$image.clone()); // this clears previously added event listeners
					self.$image[0].addEventListener('load', self.loadingComplete.bind(self));
				}

			}
			else {
				self.loadingComplete();
			}
			
		}
		else {
			self.loadingComplete();
		}

	}

	// download link
	let floorPlanDownload = suiteData.suite_floorPlanDownload;
	if (floorPlanDownload && floorPlanDownload.length && floorPlanDownload[0] && floorPlanDownload[0].url) {
		self.$downloadLink.attr('href', floorPlanDownload[0].url);
		showDataContainer(self.$downloadLink);
	}
	else if (floorPlanImageUrl) {
		self.$downloadLink.attr('href', floorPlanImageUrl);
		showDataContainer(self.$downloadLink);
	}

};

export default BuildingVisualizer;
